var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed } from "mobx";
import { Disposer } from "../Infra/Disposer";
import { getHeapGlobalEventProperties } from "../Infra/LoadHeap";
import { getAnonymousUserId } from "../Logic/AuthManager";
import { LoginPage } from "./LoginUIManager";
const WebLoginAnalyticsEvent = {
    WEB_LOGIN_PAGE_VIEWED: "WebLoginPageViewed",
};
export class LoginFlowViewModel {
    constructor(container) {
        this.disposer = new Disposer();
        this.loginUIManager = container.loginUIManager;
        this.analyticsService = container.analyticsService;
        this.authManager = container.authManager;
    }
    run() {
        this.disposer.reaction(() => this.loginPage, (loginPage) => {
            if (loginPage === LoginPage.PATIENT_LOGIN) {
                this.trackWebLoginPageViewed();
            }
        }, { fireImmediately: true, name: "LoginFlowViewModel_webLoginPageViewed" });
    }
    stop() {
        this.disposer.dispose();
    }
    get loginPage() {
        return this.loginUIManager.loginPage;
    }
    trackWebLoginPageViewed() {
        var _a, _b;
        if (navigator.webdriver) {
            return;
        }
        void this.analyticsService.trackHeapEvent({
            event: WebLoginAnalyticsEvent.WEB_LOGIN_PAGE_VIEWED,
            user_id: (_a = getAnonymousUserId()) !== null && _a !== void 0 ? _a : undefined,
            identity: (_b = this.authManager.id) !== null && _b !== void 0 ? _b : undefined,
            properties: { ...getHeapGlobalEventProperties() },
        });
    }
}
__decorate([
    computed
], LoginFlowViewModel.prototype, "loginPage", null);
